export default __webpack_public_path__ + "static/media/rocket_anim_85.91ecddd3.png";